<template>
  <div class="public-top">
    <div class="top-box">
      <div class="top-self">
        <div class="top-nav">
          <div class="nav-self" :class="{'active': item.active}" v-for="(item, index) in nav"  :key="index">
            <span v-if="item.type !== 'egpc'" @click="goPage(item.url, index)">{{ item.title }}</span>
            <el-dropdown v-if="item.type === 'egpc'" @command="handleClick">
              <span>{{ item.title }}</span><span class="el-dropdown-link"><i class="el-icon-arrow-down el-icon--right"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="/egpc">2025年会展预告</el-dropdown-item>
                <el-dropdown-item command="/inThoseYears">往届会展回顾</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="nav-self btn">
            <span class="self-btn">注册/登录</span>
          </div>
        </div>
        <img class="top-logo" src="~@/assets/images/egpc-logo.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'publicTop',
  props: {},
  data () {
    return {
      nav: [
        {
          title: '首页',
          active: true,
          type: 'home',
          url: '/'
        },
        {
          title: '关于我们',
          active: false,
          type: 'aboutUs',
          url: '/aboutUs'
        },
        {
          title: '全球会展',
          active: false,
          type: 'egpc',
          url: '/egpc',
        },
        {
          title: '合作伙伴',
          active: false,
          type: 'partnership',
          url: '/partnership'
        },
        {
          title: '积分政策',
          active: false,
          type: 'points'
        },
        {
          title: '联系我们',
          active: false,
          type: 'contact',
          url: '/contact'
        }
      ]
    }
  },
  components: {},
  computed: {},
  created () {},
  watch: {
    '$route' (to) {
      for (let i in this.nav) {
        this.nav[i].active = false
        if (this.nav[i].url === to.path) {
          this.nav[i].active = true
        }
      }
    }
  },
  methods: {
    goPage (url, index) {
      for (let i in this.nav) {
        this.nav[i].active = false
      }
      this.nav[index].active = true
      this.$router.push({
        path: url
      })
    },
    handleClick (command) {
      this.$router.push({
        path: command
      })
    }
  }
}
</script>

<style scoped>
.public-top>>>.el-dropdown-menu__item:focus, .el-dropdown-menu__item:not(.is-disabled):hover{color:#772c84;}
.public-top{height:108px;font-family:Roboto,"Helvetica Neue",Helvetica,Arial,sans-serif;}
.public-top .top-box{position: fixed;height:108px;background-color:#efefef;width:100%;z-index:1000;}
.public-top .top-box .top-self{width:1170px;margin:0 auto;position:relative;height:100%;overflow:hidden;}
.public-top .top-nav{overflow:hidden;position: absolute;top:50%;right:45px;transform:translate(0,-50%);}
.public-top .top-nav .nav-self{float:left;font-size:13px;color:#444;font-weight:600;line-height:1em;padding:15px;cursor:pointer;}
.public-top .top-nav .nav-self.active{color:#772c84;}
.public-top .top-nav .nav-self.btn{background-color:#772c84;color:#fff;border-radius:18px;margin-left:10px;}
.public-top .top-logo{display: block;height:60px;margin:24px 0;}
</style>
